export default __webpack_public_path__ + "static/media/check.8106df82.svg";